import styles from "./styles";
import {Image, SafeAreaView, Text, TouchableOpacity, View} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome5";
import React from "react";
import {SocialIcon} from "react-social-icons";

export default function SocialShare({navigation,route}){
    let url = [
        "https://www.facebook.com/share.php?u=" + route.params.appData.app_link,
        "https://www.linkedin.com/shareArticle?mini=true&url=" + route.params.appData.app_link,
        "https://twitter.com/intent/tweet?text=" + encodeURIComponent(route.params.share_text),
        "mailto:?subject=Shop2Support%20Us&body=" + encodeURIComponent(route.params.share_text),
        "https://api.whatsapp.com/send?text" + encodeURIComponent(route.params.share_text)
    ];
    return(
        <View style={styles.container}>
            <TouchableOpacity
                onPress={() => navigation.navigate(route.params.previousScreen)}>
                <View style={{marginHorizontal:20, marginVertical:50,flexDirection:"row"}}>
                    <Icon
                        name="arrow-left"
                        color='#ddddd'
                        size={20}
                    />
                    <Text style={styles.text}>Back</Text>
                </View>
            </TouchableOpacity>
            <SafeAreaView edges={['right', 'left']} style={{marginHorizontal:50}}>
                <Image source={route.params.appData.logo} style={styles.img}></Image>
                <Text style={styles.shareTitle}>Share</Text>
                <Text style={styles.shareBody}>Click to share below</Text>
                <View style={styles.socialContainer}>
                    {url.map(link => (
                        <View style={styles.socialIcon} key={link}>
                            <SocialIcon url={link} />
                        </View>
                    ))}
                </View>


            </SafeAreaView>
        </View>

    )
}